/**
 * Extracted from snippets/ns-new-upsell-v4.liquid (inline <script> at line 950).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at snippets/ns-new-upsell-v4.liquid:950) ---
  (function() {
    function updateFlashDealClaimBar() {
      const claimBars = document.querySelectorAll('[data-flash-deal-claim-bar]');
      if (claimBars.length === 0) return;

      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentDate = now.toDateString();
      
      // Generate a unique storage key based on date
      const storageKey = `flashDealClaimBar_${currentDate}`;
      
      // Calculate cycle: from last 4:01AM to next 4:00AM
      const today4_01AM = new Date(now);
      today4_01AM.setHours(4, 1, 0, 0, 0, 0);
      
      const today4_00AM = new Date(now);
      today4_00AM.setHours(4, 0, 0, 0, 0, 0);
      
      let cycleStart, cycleEnd;
      
      if (now < today4_01AM) {
        // Before 4:01AM today - cycle started yesterday at 4:01AM, ends today at 4:00AM
        cycleStart = new Date(today4_01AM);
        cycleStart.setDate(cycleStart.getDate() - 1);
        cycleEnd = today4_00AM;
      } else {
        // At or after 4:01AM today - cycle started today at 4:01AM, ends tomorrow at 4:00AM
        cycleStart = today4_01AM;
        cycleEnd = new Date(today4_00AM);
        cycleEnd.setDate(cycleEnd.getDate() + 1);
      }
      
      // Create a unique key for this cycle (based on cycle start timestamp)
      const cycleKey = `flashDealCycle_${cycleStart.getTime()}`;
      const lastResetKey = `flashDealLastReset_${currentDate}`;
      
      // Check if we need to reset (after 4:01AM and haven't reset today)
      // The lastResetKey is date-based, so it only resets once per day
      const isAfter4AM = currentHour > 4 || (currentHour === 4 && currentMinute >= 1);
      const lastReset = localStorage.getItem(lastResetKey);
      const needsReset = isAfter4AM && !lastReset;
      
      // Get or generate starting percentage for this cycle
      let startPercentage = localStorage.getItem(cycleKey);
      const lastPercentageKey = `flashDealLastPercentage`;
      // Use a simple persistent key that tracks the maximum percentage
      // This ensures we NEVER decrease, regardless of cycle calculation changes
      const lastCycleKeyKey = `flashDealLastCycleKey`;
      const storedCycleKey = localStorage.getItem(lastCycleKeyKey);
      
      // Check if we're in a new cycle (cycleKey changed)
      const isNewCycle = storedCycleKey !== cycleKey && storedCycleKey !== null;
      
      // Check if we're actually at reset time (4:01 AM) - this is when we should reset
      // Only reset during the first minute after 4:01 AM
      const isResetTime = currentHour === 4 && currentMinute >= 1 && currentMinute < 2;
      
      // Get the last stored percentage BEFORE checking for reset
      // This ensures we preserve it unless we're explicitly resetting
      const lastPercentage = localStorage.getItem(lastPercentageKey);
      let lastPercentageNum = null;
      if (lastPercentage !== null) {
        lastPercentageNum = parseFloat(lastPercentage);
      }
      
      // Only reset if we're explicitly at reset time (4:01 AM) AND need to reset
      // Don't reset just because cycle calculation changed
      if (needsReset || !startPercentage) {
        // Generate new random starting percentage between 52-65%
        startPercentage = Math.floor(Math.random() * (65 - 52 + 1)) + 52;
        localStorage.setItem(cycleKey, startPercentage.toString());
        // Store current cycle key for comparison
        localStorage.setItem(lastCycleKeyKey, cycleKey);
        if (needsReset) {
          // It's a new day after 4:01 AM - reset everything
          localStorage.setItem(lastResetKey, now.getTime().toString());
          // Clear last percentage whenever we're resetting for a new day
          // This ensures the percentage starts fresh from the new startPercentage
          localStorage.removeItem(lastPercentageKey);
        }
      } else if (isNewCycle && !isResetTime) {
        // Cycle changed but we're not at reset time
        // Update the cycle key but DON'T clear the percentage
        // This ensures we preserve the percentage across cycle calculation changes
        localStorage.setItem(lastCycleKeyKey, cycleKey);
      }
      
      startPercentage = parseFloat(startPercentage);
      const targetPercentage = 97;
      
      // Calculate progress through the cycle (time elapsed since cycle start)
      const cycleStartTime = cycleStart.getTime();
      const cycleEndTime = cycleEnd.getTime();
      const cycleDuration = cycleEndTime - cycleStartTime;
      const nowTime = now.getTime();
      let timeElapsed = nowTime - cycleStartTime;
      
      // Ensure timeElapsed is never negative (safeguard)
      if (timeElapsed < 0) {
        timeElapsed = 0;
      }
      
      // Ensure we don't exceed cycle duration
      if (timeElapsed > cycleDuration) {
        timeElapsed = cycleDuration;
      }
      
      // Calculate progress (0 = at cycle start 4:01AM, 1 = at cycle end 4:00AM)
      // Progress represents how far through the 24-hour cycle we are
      // Progress increases from 0 to 1 as time progresses from 4:01AM to 4:00AM
      let progress = 0;
      
      if (cycleDuration > 0) {
        progress = timeElapsed / cycleDuration;
      }
      
      // Clamp progress to [0, 1] - ensures valid range
      progress = Math.max(0, Math.min(1, progress));
      
      // Special handling: at or after 4:00AM, we're at maximum
      if (nowTime >= cycleEndTime || (currentHour === 4 && currentMinute === 0)) {
        progress = 1;
      }
      
      // Use exponential curve (exponent 0.4) for acceleration near 4AM
      // This ensures slow increase at first, then faster acceleration as we approach 4AM
      // exponentialProgress is monotonic: as progress increases, exponentialProgress increases
      const exponentialProgress = Math.pow(progress, 0.4);
      
      // Calculate current percentage based on exponential progress
      // Formula: startPercentage + (targetPercentage - startPercentage) * exponentialProgress
      // - When progress = 0 (4:01AM): exponentialProgress = 0 → currentPercentage = startPercentage
      // - When progress = 1 (4:00AM): exponentialProgress = 1 → currentPercentage = targetPercentage
      // - As time progresses: progress ↑ → exponentialProgress ↑ → currentPercentage ↑
      const percentageRange = targetPercentage - startPercentage;
      let calculatedPercentage = startPercentage + (percentageRange * exponentialProgress);
      
      // Ensure calculated percentage is within bounds
      calculatedPercentage = Math.max(startPercentage, Math.min(targetPercentage, calculatedPercentage));
      
      // CRITICAL: Calculate current percentage - use the MAXIMUM of calculated and last stored
      // This ensures it NEVER decreases, even if calculation changes or cycle detection changes
      let currentPercentage = calculatedPercentage;
      
      // Always use the maximum of calculated and last stored percentage
      // This guarantees monotonic increase - percentage can only increase or stay the same
      if (lastPercentageNum !== null) {
        currentPercentage = Math.max(currentPercentage, lastPercentageNum);
      }
      
      // CRITICAL: Ensure we never go below startPercentage (absolute minimum)
      currentPercentage = Math.max(startPercentage, currentPercentage);
      
      // CRITICAL: Ensure we never exceed targetPercentage (absolute maximum)
      currentPercentage = Math.min(targetPercentage, currentPercentage);
      
      // CRITICAL: Store the current percentage for next update
      // This ensures we can track monotonic increase across page loads and updates
      // We ALWAYS store the current value, which is guaranteed to be >= last value
      localStorage.setItem(lastPercentageKey, currentPercentage.toString());
      
      // Final bounds check - ensure we're within [startPercentage, targetPercentage]
      currentPercentage = Math.max(startPercentage, Math.min(targetPercentage, currentPercentage));
      
      // Round to nearest integer for display
      currentPercentage = Math.round(currentPercentage);
      
      // Update all claim bars
      claimBars.forEach(function(claimBar) {
        const fillBar = claimBar.querySelector('[data-claim-bar-fill]');
        const textBar = claimBar.querySelector('[data-claim-bar-text]');
        
        if (fillBar) {
          fillBar.style.width = currentPercentage + '%';
        }
        
        if (textBar) {
          textBar.textContent = currentPercentage + '% CLAIMED';
        }
      });
    }
    
    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateFlashDealClaimBar);
    } else {
      updateFlashDealClaimBar();
    }
    
    // Update every 6 seconds to recalculate based on time
    // More frequent updates provide smoother visual progression, especially as percentage increases
    setInterval(updateFlashDealClaimBar, 30000);
  })();
